import { render, staticRenderFns } from "./Skillfinder.vue?vue&type=template&id=12118163&scoped=true&"
import script from "./Skillfinder.vue?vue&type=script&lang=js&"
export * from "./Skillfinder.vue?vue&type=script&lang=js&"
import style0 from "./Skillfinder.vue?vue&type=style&index=0&id=12118163&lang=scss&scoped=true&"
import style1 from "./Skillfinder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12118163",
  null
  
)

export default component.exports